






















import Vue from '../../../helpers/VueBase';
import { ICustomSelectOption } from '../../../common/interfaces/shared.interface';

export default Vue.extend({
  name: `CustomSelect`,
  model: {
    event: `change`,
    prop: `value`,
  },
  props: {
    defaultOption: {
      default: ``,
      type: String,
    },
    icon: {
      default: ``,
      type: String,
    },
    options: {
      default: () => [],
      type: Array as () => ICustomSelectOption[],
    },
    title: {
      default: ``,
      type: String,
    },
  },
});
